import { ArrowBackIcon } from "@chakra-ui/icons";
import {
  Box, Container,
  Flex,
  Heading,
  HStack,
  IconButton, Input,
  Spinner, Stack,
  Text, Textarea,
} from "@chakra-ui/react";
import React, {useState} from "react";
import { useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";

import { getTest } from "../../shared/Api";
import CCIGraph from "../../shared/components/CCIGraph";
import { Paths, TestType } from "../../shared/model/Constants";
import { adminKeys } from "../../shared/QueryKeys";
import { extractData, parseDateTime } from "../../shared/Utils";

const GlobalProperties = () => {
  const navigate = useNavigate();

  const stackSpace= "10px";
  const stackPad= "8px";

  const [IdValue, setIdValue] = useState<string>("");
  const [licenseRequestStartValue, setLicenseRequestStartValue] = useState<string>("");
  const [licenseRequestEndValue, setLicenseRequestEndValue] = useState<string>("");
  const [THETA_MINValue, setTHETA_MINValue] = useState<number>(0);
  const [THETA_MAXValue, setTHETA_MAXValue] = useState<number>(0);
  const [THETA_INCREMENTValue, setTHETA_INCREMENTValue] = useState<number>(0);
  const [birnbaum_DValue, setBirnbaum_DValue] = useState<number>(0);

  function handleBackClick() {
    navigate(Paths.ADMIN);
  }

  if (false) {
  //if (!query.data) {
    return <Spinner />;
  } else {
    return (
      <Container maxW="container.lg" marginX="auto">
        <Flex>
          <IconButton
            aria-label="Volver"
            icon={<ArrowBackIcon />}
            onClick={handleBackClick}
            marginRight="2"
          />
          <Heading as='h3' size='lg'>Propiedades globales</Heading>
        </Flex>

        <HStack spacing={stackSpace} paddingBottom={stackPad}>
          <Text>Id</Text>
          <Input type="text" value={IdValue} minW="10em" resize="none" maxW="50%" maxLength={50}
                    onChange={(event)=>setIdValue(event.target.value)}/>
        </HStack>

        <HStack spacing={stackSpace} paddingBottom={stackPad}>
          <Text>License Requests desde:</Text>
          <Input type="datetime-local" id="enabledFrom"
                 value={parseDateTime(licenseRequestStartValue)} maxW="50%"
                 onChange={(e) => {
                   setLicenseRequestStartValue(e.target.value);
                 }}/>
          <Text>License Requests hasta:</Text>
          <Input type="datetime-local" id="enabledTo"
                 value={parseDateTime(licenseRequestEndValue)} maxW="50%"
                 onChange={(e) => {
                   setLicenseRequestEndValue(e.target.value);
                 }}/>
        </HStack>

        <HStack spacing={stackSpace} paddingBottom={stackPad}>
          <Text>THETA_MIN</Text>
          <Input type="text" maxW="auto" value={THETA_MINValue}
                 onChange={(e) => {
                   const value = e.target.value.replace(/\D/,'');
                   setTHETA_MINValue(+value);
                 }}/>
          <Text>THETA_MAX</Text>
          <Input type="text" maxW="auto" value={THETA_MAXValue}
                 onChange={(e) => {
                   const value = e.target.value.replace(/\D/,'');
                   setTHETA_MAXValue(+value);
                 }}/>
        </HStack>

        <HStack spacing={stackSpace} paddingBottom={stackPad}>
          <Text>THETA_INCREMENT</Text>
          <Input type="text" maxW="auto" value={THETA_INCREMENTValue}
                 onChange={(e) => {
                   const value = e.target.value.replace(/\D/,'');
                   setTHETA_INCREMENTValue(+value);
                 }}/>
          <Text>birnbaum_D</Text>
          <Input type="text" maxW="auto" value={birnbaum_DValue}
                 onChange={(e) => {
                   const value = e.target.value.replace(/\D/,'');
                   setBirnbaum_DValue(+value);
                 }}/>
        </HStack>

      </Container>
    );
  }
};

export default GlobalProperties;
